module.exports = __webpack_public_path__ + "static/media/Dec7-17.3ce551a3.png";